<div class="card m-0 p-0">
<div class="col-12 d-flex text-wrap"  [class.text-center]="button.button_style === '1010'"  [class.text-start]="button.button_style === '1100'" [class.text-end]="button.button_style === '1001'" [ngStyle]="setBg">
  <h1 [class.font-smaller]="fontSmaller" [class.responsave-font-size]="fontResize" >{{pageHeader}}</h1>
</div>
</div>
